import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';

export function useDeepCompareEffect<T>(callback: () => void, dependencies: T) {
  const prevDependenciesRef = useRef<T | undefined>(undefined);

  useEffect(() => {
    if (!isEqual(prevDependenciesRef.current, dependencies)) {
      callback();
    }

    prevDependenciesRef.current = dependencies;
  }, [callback, dependencies]);
}
